import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { parseCriteriaText } from '@backrs_ui/common-ui/src/utils/criteriaText.util';
import { Box, Typography } from '@mui/material';
var CRITERIA_TEXT_STRINGS = appStrings.modules.assessMyTrack.criteriaText;
export var CriteriaText = function (_a) {
    var text = _a.text, textSx = _a.textSx;
    var parsed = parseCriteriaText(text);
    return (_jsxs(Box, { sx: containerSx, children: [_jsx(Typography, { variant: "text-sm-regular", sx: textSx, children: parsed.main }), (parsed.counts || parsed.doesNotCount) && (_jsxs(Box, { children: [parsed.counts && (_jsxs(Typography, { variant: "text-xs-regular", sx: textSx, children: [_jsxs(Typography, { component: "span", variant: "text-xs-semibold", children: [CRITERIA_TEXT_STRINGS.counts, ' '] }), parsed.counts] })), parsed.doesNotCount && (_jsxs(Typography, { variant: "text-xs-regular", sx: textSx, children: [_jsxs(Typography, { component: "span", variant: "text-xs-semibold", children: [CRITERIA_TEXT_STRINGS.doesNotCount, ' '] }), parsed.doesNotCount] }))] }))] }));
};
var containerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        gap: backrs.spacing['spacing-lg'],
    });
};
